export default __webpack_public_path__ + "img/bd04617470dcf4d5b4148a5b41cd40d5.png";